import { render, staticRenderFns } from "./DealerStat.vue?vue&type=template&id=c1ec1a42&scoped=true&"
import script from "./DealerStat.vue?vue&type=script&lang=js&"
export * from "./DealerStat.vue?vue&type=script&lang=js&"
import style0 from "./DealerStat.vue?vue&type=style&index=0&id=c1ec1a42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ec1a42",
  null
  
)

export default component.exports